export const cardTitle = {
  color: '#1f6f52',
  fontSize: 30,
  margin: '4px 0 8px 0',
};

export const subtitle = {
  color: '#456b55',
  marginBottom: 24,
};

export const labelStyle = {
  color: '#1e6a4b',
  display: 'block',
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 6,
};

export const inputStyle = {
  border: '1px solid #bdd8c7',
  borderRadius: 8,
  boxSizing: 'border-box',
  fontSize: 15,
  padding: '10px 12px',
  width: '100%',
};

export const buttonStyle = {
  background: 'linear-gradient(90deg, #1f845b 0%, #2da56f 100%)',
  border: 'none',
  borderRadius: 8,
  color: '#ffffff',
  cursor: 'pointer',
  fontSize: 15,
  fontWeight: 700,
  padding: '11px 18px',
};

export const altButtonStyle = {
  ...buttonStyle,
  background: '#f2f8f4',
  border: '1px solid #bdd8c7',
  color: '#236946',
};

export const sectionStyle = {
  border: '1px solid #d8e9df',
  borderRadius: 10,
  marginBottom: 16,
  padding: 16,
};
